enum ErrorCode {

    NotEnoughFunds = "NotEnoughFunds",
}

export {
    ErrorCode
};
